import { Action } from 'redux'
import { combineEpics, Epic, ofType } from 'redux-observable'
import { catchError, mergeMap, of } from 'rxjs'

import { getHub } from '../../../helpers/hub'
import { patchTickerRatings } from '../../securities/actions'
import { logError } from '../../ws/actions'
import { SaveTickerRatingAction, setTickerRatingResult } from './actions'

interface UpdateTickerRatingResult {
  updatedCount: number
  tickerFound: boolean
  ratingFound: boolean
}

/*
  The hub resolves successfully even for not-found cases (MtsResponse.WithError
  nulls the result), so branch on the flags, not catchError. Order matters:
  ratingFound first, then updatedCount === 0 means the ticker matched no bonds.
  catchError handles transport/permission failures — the real error goes to
  logError for diagnostics while the user only sees a generic message.
*/
const saveTickerRatingEpic: Epic<Action> = (action$) =>
  action$.pipe(
    ofType('tickerRating.save'),
    mergeMap((action: SaveTickerRatingAction) =>
      getHub()
        .invoke<UpdateTickerRatingResult>('UpdateTickerRating', action.payload)
        .pipe(
          mergeMap((result) => {
            if (!result.ratingFound) {
              return of(
                setTickerRatingResult(
                  `${action.payload.sAndPRating} not found`,
                  true
                )
              )
            }
            if (result.updatedCount === 0) {
              return of(
                setTickerRatingResult(
                  `${action.payload.ticker} not found`,
                  true
                )
              )
            }
            return of(
              setTickerRatingResult(
                `${result.updatedCount} bonds in ${action.payload.ticker} updated to ${action.payload.sAndPRating}`,
                false
              ),
              patchTickerRatings(
                action.payload.ticker,
                action.payload.sAndPRating
              )
            )
          }),
          catchError((err) =>
            of(setTickerRatingResult('Unknown error', true), logError(err))
          )
        )
    )
  )

export default combineEpics(saveTickerRatingEpic)
